import axios from 'axios';
import md5 from 'js-md5'
import store from '../src/store'
import {getLangue} from '../src/utils/language'
const service = axios.create({
  timeout: 10000
});
let previous;
const CancelToken = axios.CancelToken;
const throttle = (config) => {
  let now = Date.now();
  if (config.method == 'post') {
    if (previous) {
      if (now - previous > 300) {
        previous = now;
      } else {
        config.cancelToken = new CancelToken(c => c('repeat'));
      }
    } else {
      previous = now;
    }
  }
};
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16).toUpperCase();
  });
}
//http request 拦截器
service.interceptors.request.use(
  (config) => {
    // 增加token信息
    let token = generateUUID()||'2';
    let appId = sessionStorage.getItem('appId')||'1851905891339603969'
    let userId = sessionStorage.getItem('userId')||'1902000401176174594'
    let key = md5(appId+token+userId).toLowerCase()||"15627be4f2bfbd95661062b97f747937";
    config.headers = {
      // 'token': token md5(appId+token+userId) 后小写"}
      'HBCONTENT':{
        'token':token,
        'appId':appId,
        'userId':userId,
        'key':key
      }
    };
    config.headers['HBCONTENT'] = JSON.stringify(config.headers['HBCONTENT'])
    var url = ''
    if(sessionStorage.getItem('host')){
      url = sessionStorage.getItem('host')
    }else{
      return Promise.reject(getLangue().network_anomaly+'获取')
    }
    config.url = url + config.url
    return config;

  },
  error => {
    //这里可打印错误信息
    return Promise.reject(getLangue().network_anomaly)
  }
);

//http response 请求
service.interceptors.response.use(
  response => {
    // console.log('成功'+JSON.stringify(response))
    let msg = response.data.msg;
    if (response.data.code === 200) {
      return response.data;
    } else {
      return Promise.reject(getLangue().network_anomaly)
      return JSON.stringify(response.data)
    }
  },
  error => {
    if (error.code === 'ECONNABORTED') { // 超时错误代码 ECONNABORTED 是由 Axios 定义的
      // 可以使用 Vue.$emit 或 Vue.$nextTick 来更新视图，例如显示一个 Toast 或 Modal
      store.commit('setfailsbtn', true)
    }
    // console.log('失败'+error)
    return Promise.reject(getLangue().network_anomaly)
  }
);

export default service;


//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 